var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconGuestAttending = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2367",
    "data-name": "Group 2367",
    transform: "translate(-748.525 -259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1674",
    "data-name": "Group 1674",
    transform: "translate(749 259)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(-0.475)",
    fill: "#2ca340"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_check_24px",
    d: "M5.751,10.02,4,8.274l-.595.59,2.341,2.341L10.775,6.18l-.59-.59Z",
    transform: "translate(-1.22 -2.634)",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconGuestAttending);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-guest-attending.d0057b4a9ac7cfe99f6c33f120f0b825.svg";